import SEOHead from "../../components/shared/SEOHead.jsx";
import SimplePage from "../../components/shared/SimplePage.jsx";
import { AgbDe, AgbEn } from "./AgbContent.jsx";

// German is the legally binding version — see AgbContent.jsx for the real
// terms and konzepte/AGB_Tales_and_Legends.docx for the source template.
export default function AGB({ lang }) {
  const path = lang === "de" ? "/agb" : "/terms";
  const altPath = lang === "de" ? "/terms" : "/agb";
  const title = lang === "de" ? "AGB" : "Terms & Conditions";

  return (
    <>
      <SEOHead lang={lang} path={path} altPath={altPath} title={title} noindex />
      <SimplePage title={title} maxWidth="900px">
        {lang === "de" ? <AgbDe /> : <AgbEn />}
      </SimplePage>
    </>
  );
}
